'use client';

import { useAttractionsStore } from '@/service/state/Attractions/useAttractionsStore';
import { TActivity } from '@/domain/Activities.domain';
import { ActivityCard } from './ActivityCard';

type TActivitiesListProps = {
    activities: TActivity[];
    partnerSlug: string;
    showReviews?: boolean;
};

export const ActivitiesList = ({ activities, partnerSlug, showReviews }: TActivitiesListProps) => {
    const showList = useAttractionsStore((state) => state.showList);
    const prices = useAttractionsStore((state) => state.prices);

    const list = showList.length ? showList : activities;
    console.log('✅ [AAA-76]', showList, activities);
    return (
        <div
            className="wrapper mb-14 mt-7 grid grid-cols-1 gap-5 px-2 md:grid-cols-2 md:px-8"
            data-test-id="activities-list"
        >
            {list.map((activity, idx) => (
                <ActivityCard
                    activity={activity}
                    partnerSlug={partnerSlug}
                    key={activity.id}
                    indexInList={idx}
                    price={prices[activity.id]}
                    showReviews={showReviews}
                />
            ))}
        </div>
    );
};
